import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const WhyNeedSection = ({ onOpenContactForm }) => {
  const section = useScrollAnimation({ threshold: 0.1 });
  return (
    <section data-testid="why-need-section" ref={section.ref} className="py-16 md:py-32 bg-[#F5F3FF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16">
          {/* Quote card — FIRST on mobile (image/visual first) */}
          <div className={`order-1 lg:order-2 lg:col-span-5 lg:pt-8 scroll-slide-right scroll-delay-2 ${section.isVisible?'scroll-visible':''}`}>
            <div className="bg-[#1E1B4B] text-white p-6 md:p-8 rounded-2xl">
              <div className="w-12 h-0.5 bg-[#A78BFA] mb-6" />
              <p className="text-lg font-normal text-white/90 leading-relaxed mb-6 italic" style={{fontFamily:"'Playfair Display',serif",fontSize:'1.25rem'}}>
                "The first entity to file a trademark application with the USPTO has priority — not the first entity to use the mark in commerce."
              </p>
              <span className="text-xs text-[#A78BFA] uppercase tracking-[0.15em] font-semibold">USPTO Filing Priority Rule</span>
            </div>
          </div>

          {/* Content — SECOND on mobile */}
          <div className={`order-2 lg:order-1 lg:col-span-7 scroll-slide-left ${section.isVisible?'scroll-visible':''}`}>
            <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-4 block font-semibold">Time-Critical</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] leading-tight mb-6" style={{fontFamily:"'Playfair Display',serif"}}>The Window to Protect Your Brand Is Narrowing.</h2>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed mb-4">In the United States, trademark rights are awarded to the first entity that files — not the first to use. While you operate under an unregistered name, anyone can file it with the USPTO and establish legal priority over you.</p>
            <p className="text-base font-normal text-[#4B5563] leading-relaxed mb-8">The distinction between owning your brand and losing it is a single decision: <strong className="text-[#1E1B4B]">filing before someone else does</strong>.</p>
            <Button data-testid="why-need-cta" onClick={onOpenContactForm} className="btn-gradient text-white font-semibold px-8 py-5 text-sm rounded-full group">
              Begin Your Filing <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
